import api from '@/api/api';
import store from '@/store';

const KEY = 'slowgo.wechat.allowance-retries';
let running = false;
let memory = [];
// Each accepted WeChat permission is one item: `grant` (this page's id for that tap), the account,
// when it was accepted, and the recording key (`operation`) once the server issued one. The key is
// asked for after the tap, never before, so its retry window starts at the grant (review F4);
// retries reuse it, so a grant is recorded at most once.
const id = i => i.grant || i.operation;
function read() { try { return [...new Map([...(JSON.parse(localStorage.getItem(KEY)) || []), ...memory].map(i => [id(i), i])).values()]; } catch (e) { return memory; } }
function write(items) { memory = items; try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) { /* unavailable storage */ } }
function update(item) { write(read().map(i => (id(i) === id(item) ? item : i))); }
export function newGrant() { return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`; }
export function accepted(grant, user) {
  const item = { grant, user, created: Date.now() };
  const items = read();
  if (!items.some(i => id(i) === grant)) { items.push(item); write(items); }
  flush();
}
export async function flush() {
  if (running || !store.state.user) return;
  running = true;
  const attempted = new Set();
  try {
    // A key the server issued expires after its retry window (24 hours); a grant still without a key
    // is kept until it is recorded.
    const items = read().filter(i => !i.operation || Date.now() - (i.issued || i.created) < 24 * 60 * 60 * 1000);
    write(items);
    // Include permissions accepted during an in-flight request, but leave failed operations
    // for the normal retry triggers instead of retrying them in a tight loop.
    while (store.state.user) {
      const user = store.state.user.id;
      const item = read().find(i => i.user === user && !attempted.has(id(i)));
      if (!item) break;
      attempted.add(id(item));
      try {
        if (!item.operation) {
          item.operation = (await api.call('POST', 'wechat/allowance-operations', { user: { id: user } })).id;
          item.issued = Date.now();
          update(item);
        }
        await api.call('POST', 'wechat/allowances', { user: { id: user }, operation: item.operation });
        write(read().filter(i => id(i) !== id(item)));
      } catch (e) {
        // Expired/mismatched operations are terminal. Network/server failures retain the same key.
        if (['expired', 'bad-request', 'wechat-unavailable'].includes(e.msg)) write(read().filter(i => id(i) !== id(item)));
      }
    }
  } finally { running = false; }
}

let retriesStarted = false;
export function startRetries() {
  if (retriesStarted) return;
  retriesStarted = true;
  // Module initialization and auth.load run concurrently; wait for the actual signed-in account.
  store.watch(state => state.user && state.user.id, flush, { immediate: true });
  window.addEventListener('online', flush);
  setInterval(flush, 30000);
}
